module.exports = __webpack_public_path__ + "static/media/hp_assess.a5399e9f.svg";